<template>
    <div class="workorderInfromation" style="background-color: #FFEFF1">
        <div class="workorderInfromation_title">
            <!--<div class="workorderInfromation_t_zhzx" :class="{'QZX':timeLineData.roleGrade=='1','ZLD':timeLineData.roleGrade=='2','ZGLD':timeLineData.roleGrade=='4','ZX':timeLineData.roleGrade=='3'}">-->
                <!--{{timeLineData.czCzdwmc}}-->
            <!--</div>-->

            <div class="workorderInfromation_t_zhzx QZX" v-if="timeLineData.czCzjskey=='WGSJ_WGY'">
                网格员
            </div>
            <div class="workorderInfromation_t_zhzx ZLD" v-if="timeLineData.czCzjskey=='WGSJ_WGZ'">
                网格长
            </div>
            <div class="workorderInfromation_t_describe">
            {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_db">
                工单推送至
            </div>
            <div class="workorderInfromation_t_describe" style="color: #1b4cfb">
                指挥中心
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
        <!--<div class="workorderInfromation_option">-->
            <!--<span class="icon-progress workorderInfromation_icon"></span>-->
            <!--<div>-->
                <!--<span class="workorderInfromation_option_label">督办内容：</span>{{timeLineData.czCzjgwb}}-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="workorderInfromation_line" v-if="timeLineData.files && timeLineData.files.length>0">-->

        <!--</div>-->
        <!--<TimeLine_file :files="timeLineData.files" v-if="timeLineData.files && timeLineData.files.length>0"></TimeLine_file>-->
    </div>
</template>

<script>
    import {reactive, ref, getCurrentInstance, onMounted, inject} from 'vue'
    export default {
        name: "cbdbInformation",
        props:["timeLineList"],
        setup(props, context) {
            // let gdId = inject("gdId");
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czCzrmc": "张倩",  //处置人名称
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "theDay": "1", //第n天"
            // })
            let timeLineData = props.timeLineList;
            return {
                timeLineData
            }
        }
    }
</script>

<style scoped>

</style>
